/* eslint-disable @typescript-eslint/no-use-before-define */
import {keyframes, styled} from '@mui/material/styles';
import * as React from 'react';

const spinnyMcSpinSpin = keyframes`
 0% {
     transform: rotate(0deg);
 }
 100% {
     transform: rotate(360deg);
 }
`;

const Ring = styled('div')<{
  size: number;
}>(({size}) => ({
  height: `${size}px`,
  width: `${size}px`,
}));

const SpinPart = styled('div')<{
  size: number;
  animationDelay: number;
  color: string | undefined;
}>(({size, animationDelay, color}) => ({
  boxSizing: 'border-box',
  display: 'block',
  position: 'absolute',
  width: `${size * 0.8}px`,
  height: `${size * 0.8}px`,
  margin: `${size * 0.1}px`,
  border: `${size * 0.1}px solid #fff`,
  borderRadius: '50%',
  animation: `${spinnyMcSpinSpin} 1s cubic-bezier(0.5, 0, 0.5, 1) infinite`,
  animationDelay: `${animationDelay}s`,
  borderColor: `${color || '#fff'} transparent transparent
      transparent`,
}));

export function Spinner({size = 32, color}: {size: number; color?: string}) {
  return (
    <Ring size={size}>
      {[-0.375, -0.25, -0.125].map((animationDelay, i) => (
        <SpinPart
          key={`part_${i}`}
          size={size}
          color={color}
          animationDelay={animationDelay}
        />
      ))}
    </Ring>
  );
}
